import type { TemplateDefinition } from '@sarnia/shared';

// Words people type that are not in a template's name but should still find it.
const SYNONYMS: Record<string, string> = {
  hair: 'barber salon beauty',
  hairdresser: 'barber salon beauty',
  nails: 'beauty salon',
  plumber: 'electrician trades engineer',
  electrician: 'plumber trades engineer',
  builder: 'trades garden architecture',
  restaurant: 'food dining menu',
  takeaway: 'food menu street',
  pub: 'brewery taproom bar',
  bar: 'brewery taproom pub',
  coffee: 'cafe roasters',
  doctor: 'dental physio clinic health',
  dentist: 'dental clinic',
  clinic: 'dental physio health',
  gym: 'fitness yoga strength',
  yoga: 'fitness wellness pilates',
  shop: 'shops store retail',
  store: 'shops shop retail',
  wedding: 'event invitation',
  charity: 'nonprofit community donate',
  church: 'community faith',
  school: 'education nursery kids',
  nursery: 'education kids school',
  course: 'education coaching online',
  lawyer: 'law solicitors professional',
  accountant: 'accountancy professional finance',
  band: 'music musician gig',
  music: 'band podcast vinyl records',
  podcast: 'creator audio',
  photographer: 'creative portfolio',
  designer: 'creative portfolio',
  game: 'gaming minecraft server retro',
  minecraft: 'gaming server community',
  hotel: 'travel stay b&b',
  travel: 'tours holiday journeys',
  car: 'automotive garage detailing mot',
  garage: 'automotive motorbike car',
  cleaner: 'cleaning local services',
  dog: 'pet grooming vet animals',
  pet: 'dog grooming daycare vet animals',
  vet: 'veterinary pets animals',
  vets: 'veterinary pets animals',
  animal: 'pets vet grooming',
  cat: 'pets vet',
  chippy: 'fish chips takeaway',
  fish: 'chips chippy seafood',
  chips: 'chippy fish takeaway',
  cottage: 'holiday self-catering stay',
  holiday: 'cottages travel stay self-catering',
  airbnb: 'holiday cottages self-catering stay',
  renovation: 'builders building extension',
  extension: 'builders renovation',
  tattoo: 'ink studio',
  venue: 'wedding events',
  salon: 'beauty barber hair nails wellness',
  barber: 'salon hair beauty',
  beauty: 'salon nails hair',
  spa: 'wellness beauty massage',
  massage: 'spa wellness physio',
  florist: 'flowers shops',
  flowers: 'florist shops',
  bakery: 'food bread cafe',
  tea: 'food cafe',
  cafe: 'coffee food brunch',
  bike: 'motorcycle garage automotive',
  motorbike: 'garage automotive custom',
  estate: 'property agent homes',
  homes: 'property estate',
  books: 'bookshop shops',
  toys: 'kids shops',
  records: 'vinyl music shops',
  vinyl: 'records music',
  print: 'merch printing',
  farm: 'food produce shop',
  portfolio: 'creative designer photographer',
  saas: 'tech startup software app',
  app: 'tech startup software',
  startup: 'tech app launch',
  blog: 'creative personal',
  cv: 'resume personal portfolio',
  resume: 'cv personal',
  drone: 'aerial photography',
  plants: 'garden shop',
  fashion: 'streetwear shops clothing',
  clothes: 'fashion streetwear shops'
};

/** True when every word in the query appears in the template's name, description or category (synonyms included). */
export function templateMatchesQuery(template: Pick<TemplateDefinition, 'name' | 'description' | 'category'>, query: string): boolean {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = `${template.name} ${template.description} ${template.category ?? ''}`.toLowerCase();
  return words.every((word) => haystack.includes(word) || (SYNONYMS[word] ?? '').split(' ').some((s) => s && haystack.includes(s)));
}
